<ng-container *ngIf="layers">
    <div class="section title">
        <div class="app-typo-h3" [title]="title">{{ title }}</div>
        <button (click)="close.emit()" class="icon-button icon-big close-button">
            <cds-icon shape="window-close"></cds-icon>
        </button>
    </div>

    <cds-form-group>
        <div class="section flex-row col-gap">
            <clr-range-container [clrRangeHasProgress]="true">
                <label>Opacity</label>
                <input
                    clrRange
                    name="opacity-range"
                    type="range"
                    max="100"
                    min="0"
                    [ngModel]="opacityPercent"
                    (ngModelChange)="setLayerOpacity($event, opacityPercent)"
                />
            </clr-range-container>
            <input
                class="number-input-no-arrow"
                name="opacity-number"
                type="number"
                max="100"
                min="0"
                [ngModel]="opacityPercent"
                (ngModelChange)="setLayerOpacity($event, opacityPercent)"
            />
        </div>
    </cds-form-group>
</ng-container>
